import { useEffect, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { DEMO } from '../lib/config'
import { Button, IconButton, useToast } from './ui'

/**
 * Vista de impresión: muestra el documento en formato A4 y el botón "Descargar PDF"
 * abre el diálogo del navegador, donde se elige "Guardar como PDF".
 * Funciona en computadora, tablet y celular sin servicios externos.
 */
export function PrintPreview({ open, onClose, title, children, extraActions }: { open: boolean; onClose: () => void; title: string; children: ReactNode; extraActions?: ReactNode }) {
  const toast = useToast()
  useEffect(() => {
    if (!open) return
    document.body.classList.add('has-print')
    const prev = document.title
    document.title = title
    return () => { document.body.classList.remove('has-print'); document.title = prev }
  }, [open, title])
  if (!open) return null
  return createPortal(
    <div className="print-overlay">
      <div className="print-bar no-print">
        <strong>{title}</strong>
        <div className="row gap-s">
          {extraActions}
          <Button variant="primary" icon="printer" onClick={() => {
            if (DEMO) toast('En la vista previa no se puede abrir la impresión. En la app publicada este botón guarda el PDF.', 'error')
            window.print()
          }}>Descargar PDF</Button>
          <IconButton icon="x" label="Cerrar" onClick={onClose} />
        </div>
      </div>
      <div className="print-scroll"><div className="print-area">{children}</div></div>
    </div>,
    document.body,
  )
}
